"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectValidAccessPointUserRoles = selectValidAccessPointUserRoles;
var hasura_1 = require("../hasura");
var isAccessPointWithinUserRoleScope_1 = require("./isAccessPointWithinUserRoleScope");
var isUserRoleAllowedOrDenied_1 = require("./isUserRoleAllowedOrDenied");
function selectValidAccessPointUserRoles(accessPoint, userRoles, options) {
    if (options === void 0) { options = { includeReservationOnly: false }; }
    var validUserRoles = userRoles.filter(function (u) { return (u.status === hasura_1.UserRoleStatus_enum.ACTIVE &&
        u.userRolePermissions.some(function (p) { return p.permissionKey === hasura_1.PermissionKey_enum.AccessPoint_Unlock; })); });
    if (!validUserRoles.length) {
        return [];
    }
    var type = accessPoint.type;
    validUserRoles = validUserRoles.filter(function (userRole) {
        var withinScope = (0, isAccessPointWithinUserRoleScope_1.isAccessPointWithinUserRoleScope)(accessPoint, userRole);
        var hasStaffAccess = userRole.userRolePermissions.some(function (p) { return (p.permissionKey === hasura_1.PermissionKey_enum.AccessPoint_StaffAccess); });
        if (withinScope && hasStaffAccess) {
            return true; // Bypasses all restrictions
        }
        // Include access points in the app for residents to create a reservation
        if (withinScope &&
            options.includeReservationOnly &&
            type === hasura_1.AccessPointType_enum.RESERVATION_ONLY &&
            userRole.role.key === hasura_1.RoleKey_enum.RESIDENT) {
            return true;
        }
        // Reservation and Amenity Access roles only apply to their respective AP types
        var isBasicAccessRole = userRole.role.key === hasura_1.RoleKey_enum.BASIC_ACCESS;
        var isReservationRole = userRole.role.key === hasura_1.RoleKey_enum.RESERVATION;
        var isAmenityAccessRole = userRole.role.key === hasura_1.RoleKey_enum.AMENITY_ACCESS;
        if (type === hasura_1.AccessPointType_enum.RESERVATION_ONLY) {
            return withinScope && isReservationRole;
        }
        if (type === hasura_1.AccessPointType_enum.AMENITY) {
            return withinScope && (isAmenityAccessRole || isBasicAccessRole);
        }
        if (userRole.role.permissionScope === hasura_1.PermissionScope_enum.ACCESS_POINT) {
            // All other roles scoped by access point are auto-allowed (e.g., "Basic Access")
            return withinScope && !isReservationRole && !isAmenityAccessRole;
        }
        var allowListed = accessPoint.accessPointRoles.some(function (accessPointRole) { return ((0, isUserRoleAllowedOrDenied_1.isUserRoleAllowListed)(accessPointRole, accessPoint, userRole)); });
        // Check allow list for cross-property access (via unit groups)
        if (type === hasura_1.AccessPointType_enum.COMMON_AREA) {
            return withinScope || allowListed;
        }
        if (type === hasura_1.AccessPointType_enum.RESTRICTED_WHITELIST) {
            return allowListed;
        }
        if (type === hasura_1.AccessPointType_enum.RESTRICTED_BLACKLIST) {
            return withinScope && !accessPoint.accessPointRoles.some(function (accessPointRole) { return ((0, isUserRoleAllowedOrDenied_1.isUserRoleDenyListed)(accessPointRole, userRole)); });
        }
        return false;
    });
    return validUserRoles;
}
//# sourceMappingURL=selectValidAccessPointUserRoles.js.map